import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Empregador, JornadaPonto } from '../../api.service';
import { RodapeCrudComponent } from '../../shared/rodape-crud.component';
import { ServicoMensagemAplicacao } from '../../shared/servico-mensagem-aplicacao';
import { ServicoRelogioPonto } from './servico-relogio-ponto';

@Component({
  selector: 'app-painel-horarios-relogio',
  standalone: true,
  imports: [CommonModule, FormsModule, RodapeCrudComponent],
  templateUrl: './painel-horarios-relogio.component.html'
})
export class PainelHorariosRelogioComponent {
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';
  @Input({ required: true }) relogioEmpregador!: Empregador;
  @Input() jornadas: JornadaPonto[] = [];

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() alterarEmpregador = new EventEmitter<void>();
  @Output() mensagem = new EventEmitter<string>();
  @Output() relogioSalvo = new EventEmitter<Empregador>();
  @Output() relogioLimpo = new EventEmitter<Empregador>();
  @Output() irParaJornadas = new EventEmitter<void>();

  constructor(
    private readonly servicoMensagemAplicacao: ServicoMensagemAplicacao,
    private readonly servicoRelogioPonto: ServicoRelogioPonto
  ) {}

  selecionarEmpregador(empregadorId: string) {
    this.empregadorSelecionadoChange.emit(empregadorId);
    this.alterarEmpregador.emit();
  }

  get jornadaQueValeNoPonto() {
    return this.servicoRelogioPonto.jornadaQueValeNoPonto(this.jornadas);
  }

  limparRelogio() {
    this.relogioEmpregador = this.servicoRelogioPonto.restaurarPadrao(this.relogioEmpregador);
    this.relogioLimpo.emit(this.relogioEmpregador);
  }

  salvarRelogio() {
    if (!this.relogioEmpregador.id) {
      this.mensagem.emit('Selecione um empregador para configurar o relogio de ponto.');
      return;
    }

    this.servicoRelogioPonto.salvar(this.relogioEmpregador).subscribe({
      next: salvo => {
        this.mensagem.emit(this.servicoMensagemAplicacao.registroSalvo(true));
        this.relogioEmpregador = this.servicoRelogioPonto.prepararConfiguracao(salvo);
        this.relogioSalvo.emit(salvo);
      },
      error: () => this.mensagem.emit('Erro ao salvar relogio de ponto.')
    });
  }
}
